import { PollIcon } from './PollIcon';

/**
 * author: Austin Andrews
 * id C4A1DAE5-04E0-47EF-84D8-CB81FA58EF87
 * name poll
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/poll.svg
 * tags
 */
export const AnalyticsIcon = PollIcon;
export default AnalyticsIcon